module.exports = {
      id: "default-author-image-usage",
      viewBox: "0 0 48 48",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#default-author-image",
      toString: function () {
        return this.url;
      }
    }